import { render, staticRenderFns } from "./PlanoExpiradoCard.vue?vue&type=template&id=70831afc"
import script from "./PlanoExpiradoCard.vue?vue&type=script&lang=ts"
export * from "./PlanoExpiradoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports